import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { withDotSeparatedProps } from '@beef/landing-constructor/library-utils';
import { CrashedComponent, withErrorBoundary } from "./boundary";
import { withCrudeMapping } from "./crude-mapping/hocs/withCrudeMapping";
// Add automatic component disable during errors

/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
export var enhancedConnect = function enhancedConnect(propsShape) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$errorBoundary = _ref.errorBoundary,
    errorBoundary = _ref$errorBoundary === void 0 ? true : _ref$errorBoundary,
    _ref$autoMapping = _ref.autoMapping,
    autoMapping = _ref$autoMapping === void 0 ? true : _ref$autoMapping;
  return function (WrappedComponent) {
    var Enhanced = WrappedComponent;
    if (autoMapping) Enhanced = withCrudeMapping()(Enhanced);
    if (errorBoundary) Enhanced = withErrorBoundary({
      fallback: function fallback(boundaryProps) {
        return /*#__PURE__*/React.createElement(CrashedComponent, _extends({}, boundaryProps, {
          "data-t-id": "src-utils"
        }));
      }
    })(Enhanced);
    if (propsShape) Enhanced = withDotSeparatedProps(Enhanced, propsShape);
    Enhanced.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.propTypes), Enhanced.propTypes);

    // Enhanced.propTypes = WrappedComponent.propTypes;
    return Enhanced;
  };
};